import { Link } from "react-router-dom";
import type { Video } from "@/types/content";
import VideoCard from "@/components/feature/VideoCard";
import SectionHeading from "@/components/feature/SectionHeading";

interface HotVideosSectionProps {
  videos: Video[];
}

export default function HotVideosSection({ videos }: HotVideosSectionProps) {
  return (
    <section aria-label="热门视频推荐" className="animate-fade-up rounded-lg bg-background-100 px-4 py-8 md:px-6 md:py-10">
      <SectionHeading
        eyebrow="Video · 热门视频"
        title="用镜头记录，比文字更近一点"
        description="原创视频栏目覆盖纪实、访谈与现场，每期 8-15 分钟。"
        action={
          <Link
            to="/category/culture"
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-3.5 py-2 text-xs text-background-50 transition-colors hover:bg-foreground-800"
          >
            进入视频频道
            <i className="ri-play-fill" />
          </Link>
        }
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {videos.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </section>
  );
}